import { render, staticRenderFns } from "./index-customer.vue?vue&type=template&id=7cebe56c&"
import script from "./index-customer.vue?vue&type=script&lang=js&"
export * from "./index-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports